<template>
  <v-col cols="12">
    <v-row>
      <v-col cols="6">
        <h3>URL of the landing page</h3>
        <v-text-field
          placeholder="https://www.democrats.org/"
          v-model="url"
          @input="scrapUrl"
          prepend-icon="link"
        />
      </v-col>
      <v-col cols="6">
        <v-card
          text
          color="grey lighten-4"
        >
          <v-card-text>
            <h4>Recommended Image Specs</h4>
            <small>Recommended image size: <strong>1,200 x 628 pixels</strong></small><br>
            <small>Image ratio: <strong>1.91:1</strong></small><br>
            <small>To maximize ad delivery, use an image that contains <strong>little or no overlaid text.</strong>
              <!-- <a>Learn more.</a>--></small>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h3>Ad Image</h3>
        <div class="input-file-block" v-ripple="{ class: 'white--text' }">
            <v-btn large color="primary">
              <v-icon left dark>attach_file</v-icon>
              Upload Image
            </v-btn>
            <input
              type="file"
              ref="file"
              @change="uploadFile"
            />
          </div>
        <transition name="component-fade" mode="out-in">
          <div class="preview-img" v-if="reviewFileUrl">
            <img
              :src="reviewFileUrl"
              width="100%"
              height="100%"
            />
            <v-btn
              small
              absolute
              right
              top
              icon
              dark
              color="grey"
              @click="clearReviewFileUrl"
            >
              <v-icon small>close</v-icon>
            </v-btn>
          </div>
        </transition>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { mapActions } from 'vuex'
// import Scraper from '../../../../../scraper'
export default {
  name: 'upload-image-uploading-block',
  data () {
    return {
      url: 'https://www.democrats.org/',
      timeout: null
    }
  },
  props: {
    reviewFileUrl: {
      type: String,
      default: null
    }
  },
  created () {
    // const scraper = new Scraper(this.url)
    // scraper.getContent()
  },
  methods: {
    uploadFile () {
      const file = this.$refs.file.files[0]
      let allowFileTypes = ['image/gif', 'image/png', 'image/jpg', 'image/jpeg']
      if (!allowFileTypes.find(type => type === file.type)) {
        this.showNotification({
          type: 'warning',
          message: ['<div>Next file types allowed: gif, png, jpg, jpeg</div>']
        })
        return false
      }
      const reviewFileUrl = URL.createObjectURL(file)
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (e) => {
        const image = new Image()
        image.src = reviewFileUrl
        image.onload = () => {
          this.$emit('setReviewFileUrl', reviewFileUrl, file, true)
          this.$emit('setMessageFields', null, 'externalUrl')
        }
      }
    },
    clearReviewFileUrl () {
      const file = this.$refs.file
      file.type = 'text'
      file.type = 'file'
      this.$emit('clearReviewFileUrl')
    },
    scrapUrl () {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        const regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/
        if (regex.test(this.url)) {
          this.$emit('setMessageFields', this.url, 'url')
          // let scraper = new Scraper(this.url)
          // scraper.getContent()
        } else {
          this.showNotification({
            type: 'warning',
            message: ['Please type a valid URL']
          })
        }
      }, 1000)
    },
    ...mapActions([
      'showNotification'
    ])
  }
}
</script>
<style lang="scss">
  .input-file-block {
    position: relative;
    margin: 8px 0;
  }
  input[type="file"] {
    opacity: 0!important;
    cursor: pointer;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 7;
    width: 100%;
    height:100%;
    position: absolute;
  }
  .preview-img {
    width: 300px;
    height: auto;
    overflow: hidden;
    position: relative;
    img {
      max-width: 100%;
      max-height: 100%;
      object-position: top center;
      object-fit: cover;
    }
  }

  .green-circle {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #4caf50;
    margin-bottom: 1px;
  }
  .component-fade-enter-active {
    transition: transform .3s ease;
  }
  .component-fade-enter {
    transform: translateY(200px);
  }
</style>
